
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authentication/RegistrationPage/RegistrationPage",
      function () {
        return require("private-next-pages/authentication/RegistrationPage/RegistrationPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authentication/RegistrationPage/RegistrationPage"])
      });
    }
  